import { Close, Delete } from "@mui/icons-material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { DialogProps } from "@toolpad/core/useDialogs";
import { enqueueSnackbar } from "notistack";
import {
  GetWorkflowInitialDocument,
  useCancelSecurityPipelineWorkflowMutation,
} from "~/operations";

export default function WorkflowCancelDialog({
  payload,
  open,
  onClose,
}: DialogProps<{ workflowMrn: string }>) {
  const [cancelWorkflow, { loading }] =
    useCancelSecurityPipelineWorkflowMutation();

  const handleCancelWorkflow = async () => {
    try {
      await cancelWorkflow({
        variables: {
          mrn: payload.workflowMrn,
        },
        refetchQueries: [GetWorkflowInitialDocument],
      });
      // Close the dialog after successful cancellation
      onClose();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      console.error("Failed to cancel workflow:", err);
      enqueueSnackbar(`Failed to cancel workflow: ${message}`, {
        variant: "error",
      });
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => onClose()}
      slotProps={{ paper: { sx: { p: 4 } } }}
    >
      <DialogTitle
        variant="h5"
        sx={{
          pb: 0.5,
          textAlign: "center",
          textTransform: "uppercase",
          fontWeight: "bold",
        }}
      >
        Cancel this fix?
        <IconButton
          aria-label="close"
          onClick={() => onClose()}
          size="large"
          sx={{
            position: "absolute",
            right: (theme) => theme.spacing(3),
            top: (theme) => theme.spacing(3),
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 3 }}>
        <Typography variant="body2" align="center">
          When you cancel a fix, it will close the pull request in GitHub, and
          close the fix in Mondoo.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={() => onClose()}>
          Don't cancel
        </Button>
        <Button
          startIcon={<Delete />}
          variant="outlined"
          color="error"
          onClick={handleCancelWorkflow}
          disabled={loading}
          loading={loading}
          loadingPosition="start"
        >
          Cancel fix
        </Button>
      </DialogActions>
    </Dialog>
  );
}
